import { Base } from './_base.model';

export class CallPlan extends Base {
  id: number;
  contact_id: string;
}
